import { ChevronLeft, ChevronRight } from "lucide-react";

interface Props {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
  onPageSize: (size: 25 | 50 | 100) => void;
}

export function Pagination({ page, pageSize, total, onPage, onPageSize }: Props) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const start = total ? (page - 1) * pageSize + 1 : 0;
  const end = Math.min(page * pageSize, total);
  return <footer className="pagination">
    <span>{start}–{end} из {total.toLocaleString("ru-RU")}</span>
    <label>Строк на странице
      <select value={pageSize} onChange={event => onPageSize(Number(event.target.value) as 25 | 50 | 100)}>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
    </label>
    <div>
      <button type="button" onClick={() => onPage(page - 1)} disabled={page <= 1} aria-label="Предыдущая страница"><ChevronLeft size={17} /></button>
      <span>{page} / {pages}</span>
      <button type="button" onClick={() => onPage(page + 1)} disabled={page >= pages} aria-label="Следующая страница"><ChevronRight size={17} /></button>
    </div>
  </footer>;
}
